import { api } from '@bilibili-maoer/web-utils'

import moment from 'moment'

import { EGiftType, EGiftTypePrefix } from './constants'

import { GuildDataReportSearchParams } from '~/features/guild/report/types'
import { RoomLogsSearchParams } from '~/features/room/report/types'

export function transformReportQueryParamsToSearchParams(params: GuildDataReportSearchParams): URLSearchParams {
  const searchParams: Record<string, string> = {
    start_date: params.start_date ?? moment().format('YYYY-MM-DD'),
    end_date: params.end_date ?? moment().format('YYYY-MM-DD'),
  }
  if (params.search_agent) {
    searchParams.search_agent = params.search_agent
  }
  if (params.search_creator) {
    searchParams.search_creator = params.search_creator
  }
  if (params.search_creator_id) {
    searchParams.search_creator_id = params.search_creator_id.toString()
  }
  if (params.p) {
    searchParams.p = params.p.toString()
  }
  if (params.pagesize) {
    searchParams.pagesize = params.pagesize.toString()
  }
  if (params.order) {
    searchParams.order = params.order
  }
  if (params.order_by) {
    searchParams.order_by = params.order_by
  }

  return new URLSearchParams(searchParams)
}

export function transformRoomLogsQueryParamsToSearchParams(params: RoomLogsSearchParams): URLSearchParams {
  const searchParams: Record<string, string> = {
    start_date: params.start_date ?? moment().format('YYYY-MM-DD'),
    end_date: params.end_date ?? moment().format('YYYY-MM-DD'),
  }

  searchParams.room_id = params.room_id.toString()
  searchParams.p = params.p.toString()

  return new URLSearchParams(searchParams)
}

export function getUrl(type: string | number, id: number) {
  if (type === EGiftType.SoundType) {
    return `${api.MISSEVAN_SITE_MAIN}${EGiftTypePrefix.SoundPrefix}${id}`
  }
  if (type === EGiftType.DramaType) {
    return `${api.MISSEVAN_SITE_MAIN}${EGiftTypePrefix.DramaPagePrefix}${id}`
  }
  return ''
}
